import { render } from "./DialValue.vue?vue&type=template&id=96796bdc&scoped=true"
import script from "./DialValue.vue?vue&type=script&lang=js"
export * from "./DialValue.vue?vue&type=script&lang=js"

import "./DialValue.vue?vue&type=style&index=0&id=96796bdc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96796bdc"]])

export default __exports__